var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49025 7.54958C4.36988 7.42157 4.20385 7.34625 4.02825 7.34001C3.85265 7.33376 3.68169 7.39709 3.55254 7.51623C3.42339 7.63537 3.34649 7.80067 3.33857 7.9762C3.33065 8.15174 3.39235 8.3233 3.51025 8.45358L5.91825 11.0662C6.27625 11.4169 6.80958 11.4169 7.14091 11.0862L7.38358 10.8469C8.25993 9.98506 9.13527 9.12217 10.0096 8.25825L10.0362 8.23158C10.8534 7.42629 11.6663 6.61672 12.4749 5.80291C12.5958 5.67638 12.662 5.5074 12.6594 5.33244C12.6568 5.15748 12.5855 4.99057 12.4609 4.86772C12.3363 4.74487 12.1684 4.67593 11.9934 4.67578C11.8184 4.67563 11.6504 4.74428 11.5256 4.86691C10.7207 5.67647 9.91179 6.48204 9.09891 7.28358L9.07225 7.31025C8.23443 8.13844 7.39554 8.96555 6.55558 9.79158L4.49025 7.54958Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6d4df0f3aecc4a0e0700599c544ba796.svg";
export { ForwardRef as ReactComponent };